import React, { useState, useEffect, useCallback, useContext } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, IconButton,
  Dialog, DialogActions, DialogContent, DialogTitle, TextField, Box, CircularProgress, Typography,
  Select, MenuItem, FormControl, InputLabel,
  Grid
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { deviceApi, storeApi, deviceGroupApi, deviceTypeApi } from '../../apiUser';
import { InfoContext } from '../../context/InfoContext';

const DeviceTypes = () => {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [openForm, setOpenForm] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [currentType, setCurrentType] = useState(null);

  const {info, setInfo} = useContext(InfoContext);

  useEffect(() => {
    const fetchDeviceTypes = async () => {
      setLoading(true);
      try {
        const response = await deviceTypeApi.get(info.selectedClient.client_id);
        console.log('Tipi di dispositivo caricati:', response.data);
        setTypes(response.data);
      } catch (err) {
        setError(err.message || 'Errore durante il caricamento dei tipi di dispositivo');
      } finally {
        setLoading(false);
      }
    };

    fetchDeviceTypes();

  }, []);


  const handleSaveType = useCallback(async (type) => {
    setLoading(true);
    console.log('Salvataggio tipo:', type);
    try {
      await deviceTypeApi.create(info.selectedClient.client_id,type);
      const updatedTypes = await deviceTypeApi.get(info.selectedClient.client_id);
      console.log('Tipi aggiornati:', updatedTypes.data);
      setTypes(updatedTypes.data);
    } catch (err) {
      setError(err.message || 'Errore durante il salvataggio del tipo di dispositivo');
    } finally {
      setLoading(false);
    }
  }, []);
  
  const handleOpenEdit = (device) => {
    setCurrentType(device);
    setOpenForm(true);
  }

  const handleOpenDelete = async (device) => {
    setLoading(true);
    try{
      const response = await deviceTypeApi.delete(info.selectedClient.client_id, device.id);
      console.log('Tipo di dispositivo eliminato:', response.data);
      const updatedTypes = await deviceTypeApi.get(info.selectedClient.client_id);
      console.log('Tipi aggiornati dopo eliminazione:', updatedTypes.data);
      setTypes(updatedTypes.data);
    } catch (err) {
      setError(err.message || 'Errore durante l\'eliminazione del tipo di dispositivo');
    }
    setLoading(false);
    setOpenDelete(false);
  };
  const handleOpenForm = () => {
    setCurrentType(null);
    setOpenForm(true);
  };

  return(
    <Box sx={{ padding: 2 }}>
      <Grid container spacing={2}>
        <Grid item size={{xs: 12, sm: 6, md: 4}}>
          <Typography variant="h4" gutterBottom>
            Tipo di Dispositivo
          </Typography>
        </Grid>
        <Grid item size={{xs: 12, sm: 6, md: 8}} display="flex" justifyContent="flex-end">
          <Button variant="contained" color="primary" onClick={() => handleOpenForm()}>
            Aggiungi Tipo
          </Button>
        </Grid>
        <Grid item size={{ xs: 12 }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Descrizione</TableCell>
                  <TableCell>Azioni</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {types.map((type) => (
                  <TableRow key={type.id}>
                    <TableCell>{type.id}</TableCell>
                    <TableCell>{type.description}</TableCell>
                    <TableCell>
                      <IconButton onClick={() => handleOpenEdit(type)}>
                        <EditIcon />
                      </IconButton>
                      <IconButton onClick={() => handleOpenDelete(type)}>
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
        <Dialog open={openForm} onClose={() => setOpenForm(false)}>
            <DialogTitle>{currentType ? 'Modifica Gruppo' : 'Aggiungi Gruppo'}</DialogTitle>
            <DialogContent>
            <TextField
                autoFocus
                margin="dense"
                label="Id"
                type="text"
                fullWidth
                variant="standard"
                value={currentType ? currentType.id : ''}
                onChange={(e) => setCurrentType({ ...currentType, id: e.target.value })}
            />
            <TextField
                autoFocus
                margin="dense"
                label="Descrizione"
                type="text"
                fullWidth
                variant="standard"
                value={currentType ? currentType.description : ''}
                onChange={(e) => setCurrentType({ ...currentType, description: e.target.value })}
            />
            </DialogContent>
            <DialogActions>
            <Button onClick={() => setOpenForm(false)}>Annulla</Button>
            <Button onClick={() => {
                handleSaveType(currentType);
                setOpenForm(false);
            }}>Salva</Button>
            </DialogActions>
        </Dialog>
    </Box>
  )


}

export default DeviceTypes;